import React from 'react'
// ReactQueryDevtools is automatically omitted from production builds
import { ReactQueryDevtools } from 'react-query-devtools'

import AuthRouter from './Router'
import ErrorBoundary from './components/features/AppError'
import { AppErrorProvider } from '@contexts/AppError'
import { TranslationProvider } from '@contexts/TranslationProvider'
import { QueryClient, QueryClientProvider } from 'react-query'

/**
 * bootstrap the router and auth state Context
 * - AUTH_STATE is available to all Components via React Context
 * - the router uses AUTH_STATE to determine which routes are available to the
 * user
 * - wire-up an app-level error handler for errors that critically disable
 * the application
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const App: React.FC = () => (
  <AppErrorProvider>
    <TranslationProvider>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <AuthRouter />
        </ErrorBoundary>
      </QueryClientProvider>
    </TranslationProvider>
    <ReactQueryDevtools initialIsOpen={false} />
  </AppErrorProvider>
)

export default App
